<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit Lesson</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body">
      <b-field label="Topic" label-position="on-border">
        <b-input :value="topic.title" disabled></b-input>
      </b-field>

      <div class="is-flex is-justify-content-space-between">
        <b-field>
          <b-switch v-model="formData.isOptional"> Optional Lesson </b-switch>
        </b-field>
      </div>
    </section>

    <footer class="modal-card-foot">
      <b-button
        label="Save Changes"
        type="is-primary"
        @click="save"
        :disabled="!hasChanges"
      />
      <b-button label="Cancel" @click="$emit('close')" />
    </footer>
  </div>
</template>

<script>
export default {
  name: "LessonEditor",

  props: {
    topic: {
      type: Object,
      required: true,
    },
    isOptional: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: {
        isOptional: this.isOptional,
      },
    };
  },

  computed: {
    hasChanges() {
      return this.formData.isOptional !== this.isOptional;
    },
  },

  methods: {
    save() {
      this.$emit("save", {
        topicId: this.topic.id,
        isOptional: this.formData.isOptional,
      });
      this.$emit("close");
    },
  },
};
</script>
